<template>
  <v-container class="pa-0">
    <template v-if="viewDataIsLoaded">
      <v-tabs
        color="accent"
        center-active
        show-arrows
      >
        <v-tab
          to="#list"
        >
          Alla
        </v-tab>
        <v-tab
          to="#qualification"
        >
          Behöriga
        </v-tab>
        <v-tab-item
          value="list"
        >
          <v-container fluid class="pa-0">
            <app-admin-data-table :tableData="viewData" :downloadable="true"></app-admin-data-table>
          </v-container>
        </v-tab-item>
        <v-tab-item
          value="qualification"
        >
          <v-container fluid class="pt-4">
            <v-row>
              <v-col cols="12" sm="8" class="pr-2">
                <div class="text-h6">Behörigheter</div>
                <!--qualification-form-fields-->
                <app-qualification-form-fields :data="viewData.qualificationData" mode="filter" :emitOptionClick="true" @onOptionClick="onQualificationClick"></app-qualification-form-fields>
              </v-col>
              <v-col cols="12" sm="4">
                <div class="text-h6">Chaufförer ({{ qualifiedDriverData.hitCount }} st)</div>
                <template v-if="!loader">
                  <div v-if="viewData.qualificationData.qlfId_ar.length == 0" class="text-body py-1">
                    (Välj en eller flera behörigheter)
                  </div>
                  <template v-else-if="qualifiedDriverData.driver_ar.length != 0">
                    <div v-for="driver in qualifiedDriverData.driver_ar" :key="driver.id" class="px-0 py-1 text-body cursor" @click="showDriver(driver.uuid)">
                      {{ driver.output }}
                    </div>
                  </template>
                  <div v-else class="text-body pv-4">
                    Inga chaufförer matchar urvalet
                  </div>
                  <div v-if="!allHitsIncluded">(finns fler...)</div>
                </template>
              </v-col>
            </v-row>
          </v-container>
        </v-tab-item>
      </v-tabs>
    </template>
    <!--loader-->
    <v-overlay
      :value="loader"
      opacity="0.8"
      z-index="1001"
    >
      <v-progress-circular
        :size="60"
        color="secondary"
        indeterminate
        :rotate="-90"
      >
      </v-progress-circular>
    </v-overlay>
    <!--snack-bar-->
    <app-snack-bar></app-snack-bar>
  </v-container>
</template>

<script>
import axios from 'axios'
import SnackBar from '../components/SnackBar'
import AdminDataTable from '../components/AdminDataTable'
import QualificationFormFields from '../components/QualificationFormFields'
import { generalMixin } from '../mixins/general'
import { urlMixin } from '../mixins/url'
import { mapGetters } from 'vuex'
import { snackBarBus } from '../main'

export default {
  components: {
    'app-snack-bar': SnackBar,
    'app-admin-data-table': AdminDataTable,
    'app-qualification-form-fields': QualificationFormFields
  },
  mixins: [generalMixin, urlMixin],
  data() {
    return {
      viewDataIsLoaded: false,
      viewData: {},
      restPath: 'driver',
      loader: true,
      qualifiedDriverData: {
        driver_ar: [],
        hitCount: 0
      }
    }
  },
  computed: {
    ...mapGetters(['loggedInData', 'access_token', 'agentName', 'getHomeRoute']),
    allHitsIncluded() {
      return this.qualifiedDriverData.hitCount ==  this.qualifiedDriverData.driver_ar.length
    }
  },
  methods: {
    onTabChange(index) {
      this.tabIndex = index
    },
    doOnViewData(returnData) {
      this.viewData = returnData
      if (returnData.qualifiedDriverData) {
        this.qualifiedDriverData = returnData.qualifiedDriverData
      }
      this.viewDataIsLoaded = true
    },
    onQualificationClick() {
      const qlfId_list = this.viewData.qualificationData.qlfId_ar.toString()
      this.$router.replace({ name: 'admin-drivers', hash: '#qualification', query: { qlfId_list: qlfId_list } })
      this.loader = true
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let postData = {
        qlfId_list: qlfId_list
      }
      let url = this.url_composeApiUrl('/admin/get-qualified-drivers')
      console.log('post', postData)
      axios.post(url, postData, config)
        .then(response => {
          console.log('response', response)
          this.loader = false
          if (response.data.success) {
            //success
            this.qualifiedDriverData = response.data.returnData.qualifiedDriverData
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    },
    showDriver(uuid) {
      this.$router.push({ name: 'admin-driver', params: { uuid: uuid } })
    },
    loadViewData() {
      let config = {
        headers: {
          'Authorization': this.access_token
        }
      }
      let postData = {}
      if (this.$route.query.qlfId_list) {
        //viewing a (signed) driver from an assignemnt
        postData.qlfId_list = this.$route.query.qlfId_list
      }
      let url = this.url_composeApiUrl('/admin/' + this.restPath)
      console.log('post', postData)
      axios.post(url, postData, config)
        .then(response => {
          console.log('response', response)
          this.loader = false
          if (response.data.success) {
            //success
            this.doOnViewData(response.data.returnData)
          } else if (this.onNonSuccessApiCall(response.data.returnData)) {
            snackBarBus.$emit('message', this.generalParseErrorArray(response.data.returnData.error_ar))
          }
        })
        .catch(error => {
          this.loader = false
          snackBarBus.$emit('message', error.toString())
        })
    }  
  },
  created() {
    //get viewData
    this.loadViewData()
  },
  destroyed() {
  }
}
</script>

<style>

</style>